
import { FormState, FormType, PageDto } from 'fourwaves-shared';
import { Component, mixins, namespace } from 'nuxt-property-decorator';
import HeaderMixin from './HeaderMixin';

const EventsModule = namespace('events');

@Component
export default class HomeHeader extends mixins(HeaderMixin) {
  @EventsModule.Getter registrationPage!: PageDto | undefined;
  @EventsModule.Getter submissionPage!: PageDto | undefined;

  get isSubmissionCtaShown(): boolean {
    const form = this.currentEvent.forms.find(x => x.type === FormType.Submission)!;
    return form.state === FormState.Open || form.state === FormState.Full;
  }

  get isRegistrationCtaShown(): boolean {
    const form = this.currentEvent.forms.find(x => x.type === FormType.Registration)!;
    return form.state === FormState.Open || form.state === FormState.FullWithWaitingList;
  }

  get bannerUrl(): string {
    return this.transl8(this.currentEvent.banner);
  }

  get eventBannerBackgroundStyle() {
    return this.bannerUrl ? { 'background-image': `url('${this.bannerUrl}?w=2000&fit=max&auto=format'` } : {};
  }
}
